import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartLanding from "@/pages/LifeMartLanding";

// Kept live as of 2026-08-06 (real recent activity observed) -- see
// src/config/featureFlags.ts LIFEMART_PUBLIC_PAGES_ENABLED doc comment.
export const Route = createFileRoute("/lifemart/access")({
  head: () => seoHead("/lifemart/access"),
  component: LifeMartLanding,
});
